import { t } from "i18next";

import { appVersion } from "../../../../../environmentConfiguration";
import { translationKeys } from "../../../../models/app-translation-keys";
import { ISharedDialogAction, ISharedDialogActionContext } from "../../../Shared/Components/Dialogs";
import { IBugReportDialogState } from "./bugReportDialogTypes";

interface IFooterActionsProps {
  onHide(): void;
  userDisplayName?: string;
  userEmail?: string;
}

const bugReportEmail = "83e8253e.smartpointonline.onmicrosoft.com@emea.teams.ms";

// build email body
const buildMailtoUrl = (state: IBugReportDialogState, userDisplayName?: string, userEmail?: string) => {
  const timestamp = new Date().toLocaleString();
  const page = window.location.href;
  const browser = navigator.userAgent;

  const user = userDisplayName && userEmail ? `${userDisplayName} (${userEmail})` : "Unknown";

  const data = state.formData;

  const bodyLines = [
    "## Bug Report",
    "",
    `Summary: ${data.summary}`,
    "",
    "What did you try to do?",
    data.steps,
    "",
    "What happened instead?",
    data.actual,
    ...(data.moreInfo?.trim() ? ["", "More information:", data.moreInfo] : []),
    "",
    "---",
    `Submitted: ${timestamp}`,
    `Page: ${page}`,
    `Browser: ${browser}`,
    `App Version: ${appVersion}`,
    `User: ${user}`,
    "",
    "Note: This report may contain personal data (e.g. user name and email). Please handle in accordance with GDPR / DSGVO.",
  ];

  const subject = encodeURIComponent(`[Bug Report] ${data.summary}`);
  const body = encodeURIComponent(bodyLines.join("\r\n"));

  return `mailto:${bugReportEmail}?subject=${subject}&body=${body}`;
};

const bugReportTranslationKeys = translationKeys.bugReport;

export const bugReportDialogFooterActions = ({ onHide, userDisplayName, userEmail }: IFooterActionsProps) => {
  return ({ sharedState }: ISharedDialogActionContext): ISharedDialogAction[] => {
    const state = sharedState as IBugReportDialogState;

    const handleSubmit = () => {
      if (!state.isValid) {
        return;
      }

      const mailtoUrl = buildMailtoUrl(state, userDisplayName, userEmail);

      window.location.href = mailtoUrl;

      onHide();
    };

    return [
      {
        label: t(bugReportTranslationKeys.cancelButton),
        isDisabled: false,
        isTextButton: true,
        isLoading: false,
        tooltip: undefined,
        tooltipOptions: undefined,
        closeOnAction: true,
        onClick: () => onHide(),
      },

      {
        label: t(bugReportTranslationKeys.submitButton),
        isTextButton: false,
        isDisabled: !state.isValid,
        isLoading: false,
        tooltip: undefined,
        tooltipOptions: undefined,
        closeOnAction: true,
        onClick: handleSubmit,
      },
    ];
  };
};
